export default {
  zh: {
    verify: '邮件验证',
    emailSucceed: '邮件验证成功',
    signSucceed: '注册成功',
    emailSucceedTipe: '您的邮件验证已成功，感谢您的使用',
    signSucceedTipe: '您的注册已完成，快去登录吧！',
    indexBack: '返回首页',
    login: '去登录',
    emailError: '邮件验证失败',
    signError: '注册失败',
    emailErrorTipe: '请重新发送邮件，再次进行验证',
    signErrorTipe: '抱歉，注册未成功，请再次进行注册',
    edit: '去修改',
    register: '去注册'
  },
  en: {
    verify: 'Email validation',
    emailSucceed: 'Email authentication succeeded',
    signSucceed: 'Registered successfully',
    emailSucceedTipe: 'Your email has been verified successfully. Thank you for using it',
    signSucceedTipe: 'Your registration has been completed, go to log in!',
    indexBack: 'back homepage',
    login: 'To log in',
    emailError: 'Email authentication failed',
    signError: 'Fail to register',
    emailErrorTipe: 'Please resend the email and verify again',
    signErrorTipe: 'Sorry, registration failed, please register again',
    edit: 'To modify',
    register: 'Go to register'
  }
}
